/**
 * Normaliser en lokasjonskode for sammenligning ved skanning.
 *
 * Lagrede lokasjonsnavn kan ha `$`-prefiks (f.eks. SafeNor `$1.13.3`), mens fysiske
 * hylleetiketter er uten prefiks. Normaliser derfor ALLTID begge sider av en
 * sammenligning — aldri muter lagrede verdier.
 */
export function normalizeBinCode(value: string): string {
  return value.trim().replace(/^\$+/, '').toLowerCase();
}
